import React, { useState, useMemo } from "react";
import { useSearchParams } from "react-router";
import PropTypes from "prop-types";
import debounce from "lodash.debounce";
import { SORT, TAG_CATEGORIES } from "constants/index";
import { GET_TAGS } from "graphql/queries";
import { DataTableProvider } from "components/DataTable";
import { PAGINATION_TYPE } from "components/Pagination";
import Card from "components/Card";
import { withIcon, ICON_TYPE, ICON_SIZE, ICON_POSITION } from "components/Icon";
import { Grid } from "components/Containers";
import Tabs from "components/Tabs";
import Status from "components/Status";
import { FormattedMessage } from "react-intl";
import { TextInput } from "components/Form";

/**
 * Tag List
 *
 * @param {Number} resultsPerPage
 */
const TagList = ({ resultsPerPage }) => {
  const [searchParams] = useSearchParams();
  const initialTab = searchParams.get("tab") ? parseInt(searchParams.get("tab")) : 0;
  const [selectedTab, setSelectedTab] = useState(initialTab);

  const [keyword, setKeyword] = useState();
  const [debounceKeyword, setDebounceKeyword] = useState();

  const debouncedSetKeyword = useMemo(() => debounce((val) => setDebounceKeyword(val), 500), []);

  const handleSearchInputChange = (_name, val) => {
    setKeyword(val);
    debouncedSetKeyword(val);
  };

  return (
    <Card>
      <Grid>
        <Grid.col start={1} end={10}>
          <Tabs
            data={TAG_CATEGORIES.map(({ label }) => label)}
            selected={selectedTab}
            onSelect={setSelectedTab}
            withUrlParams
          />
        </Grid.col>
        <Grid.col start={10} end={13}>
          <SearchInput
            placeholder="Type to search..."
            value={keyword}
            type="search"
            onChange={handleSearchInputChange}
          />
        </Grid.col>
        <Grid.col start={1} end={13}>
          <DataTableProvider
            columns={COLUMN_DATA}
            queryName={GET_TAGS}
            variables={{
              category: TAG_CATEGORIES[selectedTab].value,
              orderBy: {
                taggingsCount: SORT.desc,
              },
              filters: {
                name: debounceKeyword,
              },
            }}
            resultsPerPage={resultsPerPage}
            keyName="tags"
            paginationType={PAGINATION_TYPE.classic}
          />
        </Grid.col>
      </Grid>
    </Card>
  );
};

const COLUMN_DATA = [
  {
    label: "Name",
    cell: (row) => row?.name,
  },
  {
    label: "Enabled",
    cell: (row) => (
      <Status enabled={row?.enabled}>
        <FormattedMessage id={`Global.${row?.enabled ? `Yes` : `No`}`} />
      </Status>
    ),
  },
  {
    label: "Taggings Count",
    cell: (row) => row?.taggingsCount,
  },
];

const SearchInput = withIcon(TextInput, {
  type: ICON_TYPE.search,
  size: ICON_SIZE.medium,
  position: ICON_POSITION.overlay,
  order: 0,
});

TagList.propTypes = {
  resultsPerPage: PropTypes.number,
};

export default TagList;
